export const UNKNOWN_ERROR_OCCURRED = 'Unknown error occurred';
export const FETCH_RECENT_DEALS_FAILURE_MESSAGE = 'Failed to fetch recent deals';
export const ERROR = 'error';
export const RECENT_DEALS_SLICE_NAME = 'recentDeals';
export const MULTIPLE_TRADE_INS_LABEL = 'Multiple Trade-ins';
export const NO_TRADE_IN_LABEL = 'N/A';
export const RECENT_DEALS_SELECTED_DEALERSHIP_KEY = 'recentDealsSelectedDealership';

/**
 * Labels for elapsed time units used in recent deals UI.
 */
export const ELAPSED_TIME_LABELS = {
    SECOND: 's ago',
    MINUTE: 'm ago',
    HOUR: 'h ago',
    DAY: 'd ago'
};

// Slideout configuration constants
export const SLIDEOUT_POSITION = 'left';
export const SLIDEOUT_PANEL_WIDTH = 500;
export const SLIDEOUT_FOOTER_LAYOUT = 'rightAligned';

export const DOCKED_PANEL_WIDTH = '28.5rem';
export const DOCKED_PANEL_OFFSET_VAR = '--recent-deals-docked-offset';
export const DOCKED_PANEL_TOP_VAR = '--recent-deals-docked-top';
export const DOCKED_PANEL_LABEL = 'Recent deals';
export const DOCKED_PANEL_CLOSE_LABEL = 'Close recent deals';
